import { render } from "./mianshizhong.vue?vue&type=template&id=87951b84&scoped=true"
import script from "./mianshizhong.vue?vue&type=script&lang=js"
export * from "./mianshizhong.vue?vue&type=script&lang=js"

import "./mianshizhong.vue?vue&type=style&index=0&id=87951b84&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87951b84"]])

export default __exports__